var TagView = Backbone.View.extend({
  initialize: function () {
    this.listenTo(phillips.Events, 'addTag', this.addTag);
    this.listenTo(phillips.Events, 'showTags', this.render);
    this.listenTo(phillips.Events, 'close', this.close);
    if ($(".editTagBoxTemp").html() !== "") {
      this.template = _.template($(".editTagBadgeTemp").html());
    }
  },
  events: {
    'click .badge': 'showContacts',
    'click .delete-tag': 'deleteTag'
  },
  render: function (collection) {
    var that = this;
    if (collection) {
      this.collection = collection;
    }
    if (this.collection) {
      if (this.options.key === "departmentLocations") {
        _.forEach(this.collection.models, function (item, key) {
          var locationModel = item.get(that.options.badgeDesc);
          this.$el.append(this.template({
            badgeDesc: locationModel.get("locationName"),
            modelId: "location" + locationModel.get("locationID"),
            "tagID": item.get("departmentLocationID"),
            "propName": "departmentLocationID"
          }));
        }, this);
      } else {
        _.forEach(this.collection.models, function (item, key) {
          this.$el.append(this.template({
            badgeDesc: item.get(that.options.badgeDesc),
            "tagID": item.get("tagID"),
            "propName": "tagID"

          }));
        }, this);
      }
    }
  },
  addTag: function (model) {
    // adds passed in model from 'addTag' trigger event
    this.collection.add(model);
    this.$el.empty();
    this.render();
  },
  showContacts: function (e) {
    var locationModel = this.collection.findWhere({ "locationID": $(e.currentTarget).data('id') });
  },
  deleteTag: function (e) {
    var tagID = $(e.currentTarget).data('tag-id');
    var propName = $(e.currentTarget).data('prop-name');
    var deleteModel = this.collection.find(function (model) {
      if (model.get(propName) === tagID) {
        return model;
      }
    }, this);
    this.collection.remove(deleteModel);
    this.$el.empty();
    this.render();
  },
  close: function (e) {
    // console.log('videoTagView close');
    this.$el.empty().remove();
    this.stopListening();
  }
});

export default TagView;
